import React from 'react';
import PropTypes from 'prop-types';

import Link, { propTypes as linkPropTypes } from '../../../01_atoms/Link';
import { TagText } from '../../../01_atoms/Tag';
import FormattedText from '../../../01_atoms/FormattedText';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

const BBSidebarHighlights = ({
  title = '',
  image = null,
  headingText = '',
  nextLink = null,
  text = '',
  behaviorSettings = null,
}) => (
  <div
    className={`bb bb-sidebar-highlights ${
      styles['bb-sidebar-highlights']
    } ${generateClassNameByBehaviorSettings(behaviorSettings)}`}
  >
    {title && <TagText label={title} />}

    {image && <img src={image.url} alt={image.alt} width={200} height={200} />}

    {headingText && nextLink && (
      <p className="heading">
        <strong>
          <Link {...nextLink}>
            <a>{headingText}</a>
          </Link>
        </strong>
      </p>
    )}

    {headingText && !nextLink && (
      <p className="heading">
        <strong>{headingText}</strong>
      </p>
    )}

    {text && <FormattedText className="text" text={text} />}
  </div>
);

BBSidebarHighlights.propTypes = {
  title: PropTypes.string,
  image: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
  }),
  headingText: PropTypes.string,
  nextLink: PropTypes.shape(linkPropTypes),
  text: PropTypes.string,
  behaviorSettings: behaviorSettingsProps,
};

export default BBSidebarHighlights;
